import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyFieldText: {
		id: 'issue-empty-field-text.empty-field-text',
		defaultMessage: 'None',
		description: 'Text to indicate that a given issue field has no value set',
	},
});
